import { render } from "./PatientsDatatableFormLoginForm.vue?vue&type=template&id=7f7ae5b1"
import script from "./PatientsDatatableFormLoginForm.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__